var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"form-button",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.addNthBtnClick}},[_c('span',{staticClass:"form-button__text form-button__text--plus"},[_vm._v(" "+_vm._s(_vm.next)+"人目を追加する ")])])}
var staticRenderFns = []

export { render, staticRenderFns }